import type { HubModule } from "core-fe-lib/components-shadcn/shell/types";
import { architectKeyRoutes } from "./routes";
import { getArchitectKeyLinks } from "./links";
import enUS from "./i18n/en-US";
import fr from "./i18n/fr";

// Architect keys are a cross-cutting auth concern — a single self-identifying
// bearer authenticates the architect, care, and lms MCP endpoints (backend:
// internal/aitooling/architectkey). The key-management UI therefore lives in
// its own module rather than under aiemployee. The REST endpoints still live in
// the aiemployee OpenAPI spec (/api/v1/aiemployee/architect/keys), so the page
// consumes @/openapi/aiemployee.
export const ArchitectKeyModule: HubModule = {
  id: "architectkey",
  name: "Architect Keys",
  routes: (layouts) => architectKeyRoutes(layouts.MainLayout),
  navLinks: (ctx) => getArchitectKeyLinks(ctx.t),
  messages: { "en-US": enUS, fr },
};
